import React from 'react';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { PopoverAnchorProps } from '../types';
import { usePopoverContext } from '../PopoverContext';
import classes from './index.module.scss';

const PopoverAnchor = ({
  children,
  as: Element = 'div',
  disabled,
  dataTestId,
  ariaHasPopup,
  fullWidth,
  onFocus,
  onBlur,
}: PopoverAnchorProps) => {
  const {
    open,
    setOpen,
    triggerEvent,
    floatingData: { refs },
  } = usePopoverContext();
  const { isTouch } = getContext();

  const triggerEventListeners = {
    click: {
      onClick: () => {
        setOpen(!open);
      },
    },
    hover: {
      onMouseEnter: () => {
        setOpen(true);
      },
      onMouseLeave: () => {
        setOpen(false);
      },
    },
  };

  const getEventListeners = () => {
    if (disabled) {
      return {};
    }
    return {
      onFocus,
      onBlur,
      ...(isTouch ? triggerEventListeners.click : triggerEventListeners[triggerEvent]),
    };
  };

  return (
    <Element
      className={classNames(classes.trigger, { [classes.fullWidth]: fullWidth })}
      ref={refs.setReference}
      aria-expanded={open}
      aria-haspopup={ariaHasPopup}
      data-testid={dataTestId}
      {...getEventListeners()}
    >
      {children}
    </Element>
  );
};

PopoverAnchor.displayName = 'PopoverAnchor';

export default PopoverAnchor;
